module.exports = __webpack_public_path__ + "img/project7_3.png.8d68548d.webp";